import { createStyles, makeStyles } from '@material-ui/core';
import { Dashboard } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { useDocumentPermissions, useLocalization, useViewerState } from "../../hooks/index.js";
import { ToggleBase } from "./toggle-base.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    iconButton: {},
    icon: {},
    iconActive: {
      fill: theme.palette.primary.main
    }
  });
});
/**
 * Document widget component that toggles the displaying of the shapes
 */
export const ToggleShapesWidget = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const viewerState = useViewerState();
  const permissions = useDocumentPermissions();
  return /*#__PURE__*/React.createElement(ToggleBase, {
    disabled: !permissions.canEdit,
    classes: classes,
    active: viewerState.showShapes,
    title: localization.toggleShapes,
    setValue: v => viewerState.updateState({
      showShapes: v
    })
  }, /*#__PURE__*/React.createElement(Dashboard, {
    className: clsx(classes.icon, {
      [classes.iconActive]: viewerState.showShapes
    })
  }));
};
//# sourceMappingURL=toggle-shapes.js.map